import React, { useState } from "react";

import { useSelector } from "react-redux";

import { useTranslation } from "react-i18next";

import { useQuery } from "react-apollo";

import gql from "graphql-tag";

import LoadMoreButton from "../../components/LoadMoreButton/LoadMoreButton";

import { LANGUAGES } from "../../constants";

import { loadMoreTexts } from "../../assets/Helpers";

import "./ProductSection.scss";

import ThemeSection from "../ThemeSection/ThemeSection";
import ProductItem from "./ProductItem/ProductItem";
import ProductsContainer from "./ProductsContainer/ProductsContainer";
import ProductsLoader from "./ProductsContainer/ProductsLoader";
import ProductSectionTitle from "./ProductSectionTitle/ProductSectionTitle";
import ProductTitleLoader from "./ProductSectionTitle/ProductTitleLoader";

const SECTION_QUERY = gql`
  query getProductSectionBySlug($slug: String, $limit: Int, $after: String) {
    productCategories(where: { slug: [$slug], search: $slug }) {
      nodes {
        id
        name
        productCatEn {
          categoryNameEnglish
        }
      }
    }
    products(where: { category: $slug }, first: $limit, after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      nodes {
        id
        productId
        productAttributes {
          englishProductName
        }
        ... on SimpleProduct {
          id
          image {
            id
            sourceUrl(size: MEDIUM)
          }
          name
          slug
          onSale
          salePrice
          regularPrice
          stockStatus
        }
      }
    }
  }
`;

const ProductSection = (props) => {
  const { t } = useTranslation();
  const { language } = useSelector((state) => state.user);
  const { loading, error, data, fetchMore } = useQuery(
    props.customQuery || SECTION_QUERY,
    {
      variables: {
        after: "",
        slug: props.slug,
        limit: props.limit
      }
    }
  );
  const [buttonText, setButtonText] = useState(loadMoreTexts.default);

  if (loading) {
    return (
      <>
        <ThemeSection>
          <ProductTitleLoader />
          <ProductsLoader total={props.limit} />
        </ThemeSection>
      </>
    );
  }

  if (error) {
    return (
      <>
        <ThemeSection>
          <p>{t("title.please_try_again")}</p>
        </ThemeSection>
      </>
    );
  }

  const isArchive = props.isArchive,
    products = data.products.nodes,
    category = data.productCategories.nodes[0];

  const handleClick = () => {
    setButtonText(loadMoreTexts.loading);

    fetchMore({
      variables: {
        after: data.products.pageInfo.endCursor
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        const newNodes = fetchMoreResult.products.nodes;
        const pageInfo = fetchMoreResult.products.pageInfo;

        if (newNodes.length) {
          setButtonText(loadMoreTexts.default);
        }

        return newNodes.length
          ? {
              productCategories: data.productCategories,
              products: {
                __typename: previousResult.products.__typename,
                nodes: [...previousResult.products.nodes, ...newNodes],
                pageInfo
              }
            }
          : previousResult;
      }
    });
  };

  return (
    <>
      <ThemeSection>
        <ProductSectionTitle
          isArchive={isArchive}
          slug={props.slug}
          title={
            props.customTitle ||
            (language === LANGUAGES.en &&
            category.productCatEn.categoryNameEnglish
              ? category.productCatEn.categoryNameEnglish
              : category.name)
          }
        />
        <ProductsContainer>
          {products.length === 0 ? (
            <h3 className="ProductSection__error mt-5">
              {t("description.no_products_for_category")}
            </h3>
          ) : (
            products.map((product) => {
              return <ProductItem key={product.id} {...product} />;
            })
          )}
        </ProductsContainer>
      </ThemeSection>
      {isArchive && data.products.pageInfo.hasNextPage && (
        <LoadMoreButton title={buttonText} onClick={() => handleClick()} />
      )}
    </>
  );
};

export default ProductSection;
